export default {"src":"/_next/static/media/install-illustration.54916489.svg","height":240,"width":241,"blurWidth":0,"blurHeight":0};